module.exports = __webpack_public_path__ + "static/img/Portal-Banner-Mondo-Menu.4f95593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Portal-Banner-Mondo-Menu.png
// module id = 42
// module chunks = 14